import {useSelector} from "react-redux";
import {RootState} from "../store";
import {UserState} from "../store/slices/user-slice";

export default function useUser(): UserState {
  return useSelector((state: RootState) => state.user);
}
